import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { TranslateUiModule } from '@core/translation/translate-ui.module';
import { AppDatepickerModule } from '@ui-kit/app-datepicker/app-datepicker.module';
import { AppSelectModule } from '@ui-kit/app-select/app-select.module';
import { CommonPipesModule } from '@ui-kit/pipes/common-pipes.module';
import { PeriodPickerCalendarComponent } from './period-picker-calendar.component';

@NgModule({
  declarations: [PeriodPickerCalendarComponent],
  exports: [PeriodPickerCalendarComponent],
  imports: [
    CommonModule,
    AppSelectModule,
    TranslateUiModule,
    AppDatepickerModule,
    CommonPipesModule,
    MatDatepickerModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatButtonModule
  ]
})
export class PeriodPickerCalendarModule {}
